import { render, staticRenderFns } from "./SectionRemoveError.vue?vue&type=template&id=37921211&scoped=true&"
import script from "./SectionRemoveError.vue?vue&type=script&lang=js&"
export * from "./SectionRemoveError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37921211",
  null
  
)

export default component.exports